import { createLucideIcon } from "lucide-react";

export const Taxes = createLucideIcon(
    "Taxes",
    [
        [
            "path",
            {
                d: "M11 18.5H5C3.34315 18.5 2 19.8431 2 21.5C2 21.7761 2.22386 22 2.5 22H11",
                key: "bsylyn",
            },
        ],
        [
            "path",
            {
                d: "M2 8.56907C2 7.37289 2.48238 6.63982 3.48063 6.08428L7.58987 3.79744C9.7431 2.59915 10.8197 2 12 2C13.1803 2 14.2569 2.59915 16.4101 3.79744L20.5194 6.08428C21.5176 6.63982 22 7.3729 22 8.56907C22 8.89343 22 9.05561 21.9646 9.18894C21.7785 9.88945 21.1437 10 20.5307 10H3.46928C2.85627 10 2.22152 9.88944 2.03542 9.18894C2 9.05561 2 8.89343 2 8.56907Z",
                key: "zmqia0",
            },
        ],
        [
            "path",
            {
                d: "M21.5 14.5L14.5 21.5",
                key: "8t9rkr",
            },
        ],
        [
            "path",
            {
                d: "M4 10V18.5",
                key: "uqrpc6",
            },
        ],
        [
            "path",
            {
                d: "M8 10V18.5",
                key: "2he1sa",
            },
        ],
        [
            "circle",
            {
                cx: "15.25",
                cy: "15.25",
                key: "ff1zou",
                r: "0.75",
            },
        ],
        [
            "circle",
            {
                cx: "20.75",
                cy: "20.75",
                key: "xsul5a",
                r: "0.75",
            },
        ],
    ],
);
